module.exports = __webpack_public_path__ + "07d9d774647a3b8248063071cddb4e8b.png";